
<template>
  <izt-loading v-model:visible="configStore.loading" :text="configStore.loadingText || undefined" />
  <router-view />
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useConfigStore } from '@/stores/modules/config.js'
import { useUserStore } from '@/stores/modules/user.js'
import ai_bot_avatar from '@/assets/img/ai_bot_avatar.png'

const route = useRoute()
const userStore = useUserStore()
const configStore = useConfigStore()

// 使用 storeToRefs 保持响应式
const { exhibitionId: storeExhibitionId, lang: storeLang } = storeToRefs(userStore)

// 合并路由参数和 store 的 exhibitionId，只 watch 单一源避免重复触发
const exhibitionId = computed(() => route.query.exhibitionId || storeExhibitionId.value)
// lang
const Lang = computed(() => route.query.lang || storeLang.value)

watch(exhibitionId, (id) => {
  if (id) {
    configStore.fetchColors(id)
    userStore.assistantSetting()
  }
}, { immediate: true });
// 同时监听路由参数和 store 中的 exhibitionId
watch(Lang, (lang) => {
    // 更新配置
    if (lang) {
      userStore.setLang(lang)
    }
  },
  { immediate: true }
);
</script>

<style lang="scss">
.customize-dialog .van-dialog__message {
  line-height: 50px !important;
}
.ai-action-sheet .sheet-main-container {
  padding: 0!important;
}
.ai-action-sheet .header-container {
  background-color: #fff;
}
.ai-assistant-container {
  height: 90vh;
  overflow: hidden;
  background-color: #fff;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>